import React, { useState } from 'react';
import { MDBAlert } from 'mdb-react-ui-kit';

function AlertComponent({ type, messages, resetAlert }) {
  const [isVisible, setIsVisible] = useState(true);
  const onClose = () => {
    setIsVisible(false);
    resetAlert({ type: '' , message: ''});
  }

  if (!messages || messages.length === 0 || !isVisible) return null;

  return (
    <MDBAlert open className={`w-100 alert-${type}`} color={type}>
      <span onClick={onClose} className="close-icon">
        <i className="fas fa-times"></i>
      </span>
      {Array.isArray(messages)
        ? messages.map((msg, index) => <div key={index}>{msg}</div>)
        : messages}
    </MDBAlert>
  );
}

export function SuccessAlert({ success, messages , resetAlert}) {
  if (!success) return null;
  return <AlertComponent type="success" messages={messages} resetAlert={resetAlert}/>;
}

export function ErrorAlert({ error, messages, resetAlert }) {
  if (!error) return null;
  return <AlertComponent type="danger" messages={messages} resetAlert={resetAlert} />;
}
